var map = {
	"./coverage-icon.svg": 45723,
	"./coverageE.svg": 554,
	"./coverageESC.svg": 57197,
	"./coverageESCP+IL.svg": 86320,
	"./coverageESCP.svg": 73726,
	"./coverageESCP_IL.svg": 26875,
	"./coverageP.svg": 65184,
	"./coverageP_IL.svg": 42723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47696;